import { fetchMainTaskEpics } from '../../../projects/developmentSprint.service'

import { mapEpicListToOptions } from './epicUtils'

const optionsCache = new Map()
const inflight = new Map()

const parseEpicList = (response) => {
    const body = response?.data ?? {}
    if (Array.isArray(body?.data)) return body.data
    if (Array.isArray(body)) return body
    return []
}

export const getCachedProjectEpicOptions = (projectId) => {
    if (!projectId) return null
    return optionsCache.get(projectId) ?? null
}

export const fetchProjectEpicOptions = async (
    projectId,
    { force = false } = {}
) => {
    if (!projectId) return []

    if (force) {
        optionsCache.delete(projectId)
    } else if (optionsCache.has(projectId)) {
        return optionsCache.get(projectId)
    }

    if (!force && inflight.has(projectId)) {
        return inflight.get(projectId)
    }

    const request = (async () => {
        try {
            const response = await fetchMainTaskEpics({ projectId })
            const options = mapEpicListToOptions(parseEpicList(response))
            optionsCache.set(projectId, options)
            return options
        } catch {
            if (!optionsCache.has(projectId)) {
                optionsCache.set(projectId, [])
            }
            return optionsCache.get(projectId) ?? []
        } finally {
            if (inflight.get(projectId) === request) {
                inflight.delete(projectId)
            }
        }
    })()

    inflight.set(projectId, request)
    return request
}

export const clearProjectEpicOptionsCache = (projectId) => {
    if (projectId) {
        optionsCache.delete(projectId)
        inflight.delete(projectId)
        return
    }
    optionsCache.clear()
    inflight.clear()
}
